module.exports = __webpack_public_path__ + "static/media/img106_R.3babda15.jpg";